exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stackSearchField{padding:0 5px;z-index:1}.stackSearchFieldLabel{display:block;height:100%}.stackSearchFieldInput{width:300px}.stackSearchFieldIntroduction{transform:translate(2px,-2px);padding:0 5px;z-index:-1;box-shadow:0 1px 4px rgba(12,12,13,.1);background-color:#fff;color:var(--grey-50);font-size:.9em;line-height:2}.stackSearchFieldIntroduction.isDisplayed{transition:transform .15s var(--animation-curve),opacity .15s ease-in-out}.stackSearchFieldIntroduction.isHidden{opacity:0;transform:translateY(-100%);transition:transform .15s steps(1),opacity .15s ease-in-out}", ""]);

// exports
